import React, { FC, useEffect, useRef, useState } from 'react';
import { appStore } from '@store';
import { METRICS } from '@types';
import { useT } from '@hooks';
import styled from 'styled-components';

const Container = styled.div`
	margin-top: 30px;
`;

const Title = styled.h3`
	color: ${({ theme }) => theme.colors.text1};
	font-size: 26px;
	font-weight: 700;
	letter-spacing: 0.41px;
	line-height: 32px;
`;

const Items = styled.div`
	margin-top: 20px;
`;

const Item = styled.p`
	color: ${({ theme }) => theme.colors.text1};
	font-size: 17px;
	line-height: 22px;
	margin-bottom: 14px;
	padding-left: 22px;
	position: relative;

	&:before {
		background: linear-gradient(225deg, rgb(84, 34, 133) 0%, rgb(34, 34, 102) 100%);
		background: ${({ theme }) => theme.colors.primaryGradient8};
		border-radius: 12px;
		content: '';
		height: 12px;
		left: 0;
		margin-right: 20px;
		position: absolute;
		top: 5px;
		width: 12px;
	}

	&:last-child {
		margin-bottom: 0;
	}
`;

export const Benefits: FC = props => {
	const { surveyStore, unitsStore } = appStore;
	const { answers } = surveyStore;
	const units = unitsStore.isMetrics ? METRICS.KG : METRICS.LBS;
	const [deltaWeight, setDeltaWeight] = useState<number>(0);
	const itemsRef = useRef<HTMLDivElement>(null);
	const { T } = useT();

	const benefitsItems = [
		T('payment_text_6_8'),
		T('payment_text_6_9'),
		T('payment_text_6_10'),
		T('payment_text_6_11'),
		T('payment_text_6_12'),
		T('payment_text_6_13'),
	];

	useEffect(() => {
		let curentWeight;
		let goalWeight;
		if (answers.weight?.[0]) {
			curentWeight = JSON.parse(answers.weight?.[0]).value;
		}
		if (answers.target_weight?.[0]) {
			goalWeight = JSON.parse(answers.target_weight?.[0]).value;
		}

		setDeltaWeight(Number(curentWeight) - Number(goalWeight));
	}, []);

	useEffect(() => {
		if (deltaWeight && itemsRef.current) {
			const bElement = itemsRef.current.querySelector('b');
			if (bElement) {
				bElement.innerHTML = `${deltaWeight} ${units}`;
			}
		}
	}, [deltaWeight]);

	return (
		<Container>
			<Title>{T('payment_text_6_7')}</Title>
			<Items ref={itemsRef}>
				{benefitsItems.map((item, index) => (
					<Item key={index} dangerouslySetInnerHTML={{ __html: item }} />
				))}
			</Items>
		</Container>
	);
};
